// extracted by mini-css-extract-plugin
export default {"scrollableUserList":"UsersList-module__scrollableUserList--Ywe8t"};